import { createApiRef } from '@backstage/core-plugin-api';
import { WayfinderBackendClient } from './WayfinderBackendClient';

export const wayfinderBackendApiRef = createApiRef<WayfinderBackendClient>({
    id: 'plugin.wayfinder.api',
});
